/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantOrgAccessRecord } from './tenantOrgAccessRecord';
import { RequestAccessTypeEnum } from './requestAccessTypeEnum';


export interface TenantOrgAccessInfo { 
    /**
     * Email address to request access
     */
    email?: string;
    request_type: RequestAccessTypeEnum;
    requests?: Array<TenantOrgAccessRecord>;
}
export namespace TenantOrgAccessInfo {
}


